import Auth, { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { CognitoUserSession } from "amazon-cognito-identity-js";
import env from "../app/Environment";

const configuration = {
  cookieStorage: {
    domain: window.location.hostname,
    secure: window.location.hostname !== "localhost",
  },
  region: env.region,
  userPoolId: env.userPoolId,
  userPoolWebClientId: env.userPoolClientId,
  clientId: env.userPoolClientId,
  oauth: {
    domain:
      `${env.userPoolDomain}.auth.${env.region}.amazoncognito.com`,
    scope: ["openid", "email", "profile"],
    redirectSignIn: env.redirectSignIn,
    redirectSignOut: env.redirectSignOut,
    responseType: "code",
  },
};
Auth.configure(configuration);

export function currentSession(): Promise<CognitoUserSession> {
  return Auth.currentSession();
}

export function loginInvitedUser() {
  return Auth.federatedSignIn();
}

export function loginWithGoogle() {
  return Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Google,
  });
}

export function signOut() {
  return Auth.signOut();
}
